import Create from '../views/users/Create.vue'
import Index from '../views/users/Index.vue'
import Update from '../views/users/Update.vue'

export default [
    {
        path: '/users',
        name: 'users',
        component: Index,
        meta: { title: 'Benutzer', requiresZmuekish: true }
    },
    {
        path: '/users/index',
        redirect: '/users'
    },
    {
        path: '/users/create',
        name: 'users/create',
        component: Create,
        meta: { title: 'Benutzer anlegen', requiresZmuekish: true }
    },
    {
        path: '/users/:id',
        name: 'users/update',
        component: Update,
        meta: { title: 'Benutzer bearbeiten', requiresZmuekish: true }
    },
]
